"use strict";
exports.__esModule = true;
exports.TECHNICAL_ISSUE = void 0;
exports.TECHNICAL_ISSUE = {
    MAINTEXT: 'We’re experiencing technical issues.',
    SUBTEXT_LINE_1: 'We couldn’t load your rent information. Try again later and',
    SUBTEXT_LINE_2: 'if the problem persists.',
    SUBTEXT_BOLD_LINK: 'contact support',
    CTA: 'Try again'
};
